import { Component, OnInit, AfterViewInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/globals/user';
import { AuthService } from 'src/app/core/auth.service';
import { PermissionsService } from 'src/app/core/permissions.service';
import { GlobalService } from '../../services/global.service';
import { version,production_version,dataanalysis_version } from 'package.json';
import { LoaderService } from '../../loader/loader.service';
import { RouteObject } from 'src/app/globals/globals';
import { SYSTEM_ROUTES, 
         PROD_UTILITIES, 
         PROD_PROCESS, 
         PROD_PROCESS_OTHER, 
         PROD_PROCESS_VU, 
         PROD_TOOLS, 
         DEVICES,
         REPORTS, 
         SERVICE, 
         DATA_ANALYSIS, 
         CONNECTORS, 
         PROD_PROCESS_DOCKING_STATION} from './sidebar-items';

declare const $: any;
declare const Waves: any;
declare const jQuery: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  photo: string = 'assets/images/SQA-iO-Logo.png';
  doctorName: string;
  designation: string;
  subscription: Subscription;
  currentAdminType: string;
  currentVersion: string;
  productionVersion: string;
  //marketingVersion: string;
  datanalysisVersion: string;
  
  isSystemHidden = true;
  isProductionUtilsHidden = true;
  isProductionProcessHidden = true;
  isProductionProcessOtherHidden = true;
  isProductionProcessVUHidden = true;
  isProductionProcessDockingSHidden = true;
  isDevicesHidden = true;
  isProductionToolsHidden = true;
  isReportsHidden = true;
  isServiceHidden = true;
  isDataAnalysisHidden = true;
  isConnectorsHidden = true;
  

  isSubServiceHidden = false;
  isSupportHidden = false;
  isCustomersHidden = false;
  isMarketingHidden = false;
  isSubMarketingHidden = false;
  isQCHidden = false;

  systemRoutes: Array<RouteObject> = [];
  prodUtilsRoutes: Array<RouteObject> = [];
  prodProcessRoutes: Array<RouteObject> = [];
  prodProcessOtherRoutes: Array<RouteObject> = [];
  prodProcessVURoutes: Array<RouteObject> = [];
  prodProcessDockingSRoutes: Array<RouteObject> = [];
  prodToolsRoutes: Array<RouteObject> = [];
  devicesRoutes: Array<RouteObject> = [];
  reportsRoutes: Array<RouteObject> = [];
  serviceRoutes: Array<RouteObject> = [];
  dataAnalysisRoutes: Array<RouteObject> = [];
  connectorsRoutes: Array<RouteObject> = [];
  permissions: Subscription;

  // Printer Configuration is restricted to a named list of people, held as an
  // array of emails in System/permissions.printerConfigurationPage. This is
  // specific to that one menu item; every other route still goes by the
  // per-role booleans in System/permissions/AdminSite.
  private printerConfigAllowed = false;
  private currentEmail = '';

  constructor(public authService: AuthService,private global: GlobalService, public loaderService: LoaderService, private permissionsService: PermissionsService) {


    this.subscription = authService.user.subscribe((user) => {
      console.log('current user ', user);
      if (user !== null && user !== undefined) {
        this.currentAdminType = user.adminType;
        this.currentEmail = user.email || '';
        this.createMenuItems();
      }
    });

    
    this.currentVersion = version;
    this.productionVersion = production_version;
    //this.marketingVersion = marketing_version;
    this.datanalysisVersion = dataanalysis_version;
  }

  ngOnInit() {
    this.sidemenuCollapse();
    this.initLeftSidebar();
  }
  
  ngAfterViewInit(): void {
  }

  createMenuItems() {
    console.warn('LOGIN STATUS', this.authService.isLoggedIn);
    // Settle the Printer Configuration email list first, so that item is
    // decided at the same time as every other menu entry.
    this.loadPrinterConfigAccess().then(() => this.buildMenuItems());
  }

  /**
   * Read System/permissions.printerConfigurationPage and record whether the
   * signed-in email appears on it. Fails closed: a missing document, a missing
   * key or a read error all leave the item hidden.
   */
  private loadPrinterConfigAccess(): Promise<void> {
    return this.permissionsService.isPrinterConfigAllowed(this.currentEmail)
      .then((allowed) => { this.printerConfigAllowed = allowed; });
  }

  private buildMenuItems() {
    this.permissions = this.authService.allPermissions?.subscribe(permissions => {
      console.log('ADMIN TYPE', this.currentAdminType);
      permissions.docs.forEach(permission => {
        if (permission.id === this.currentAdminType) {
          let perms = permission.data()
          console.warn(perms);
          SYSTEM_ROUTES.forEach((routeItem: RouteObject) =>{
            // Printer Configuration goes by the email allow-list instead of the
            // role flag; every other System route is unchanged.
            const allowed = routeItem.childRoute === PermissionsService.PRINTER_CONFIG_ROUTE
              ? this.printerConfigAllowed
              : perms[routeItem.childRoute];
            this.systemRoutes.push({routeForHide: allowed, childRoute: `system/${routeItem.childRoute}`, title: routeItem.title});
            if (allowed === true) this.isSystemHidden = false;
            console.log(routeItem.childRoute, allowed, this.isSystemHidden)
          });
          PROD_UTILITIES.forEach((routeItem: RouteObject) =>{
            this.prodUtilsRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `production-utilities/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isProductionUtilsHidden = false;
          });
          PROD_PROCESS.forEach((routeItem: RouteObject) =>{
            this.prodProcessRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `production-process/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isProductionProcessHidden = false;   
          });
          PROD_PROCESS_OTHER.forEach((routeItem: RouteObject) =>{
            this.prodProcessOtherRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `production-process/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isProductionProcessOtherHidden = false;
          });
          PROD_PROCESS_VU.forEach((routeItem: RouteObject) =>{
            this.prodProcessVURoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `production-process-vu/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isProductionProcessVUHidden = false;
          });
          PROD_PROCESS_DOCKING_STATION.forEach((routeItem: RouteObject) => {
            this.prodProcessDockingSRoutes.push({routeForHide: perms[routeItem.childRoute] || true, childRoute: `production-process-docking-station/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isProductionProcessDockingSHidden = false;
          });
          PROD_TOOLS.forEach((routeItem: RouteObject) =>{
            this.prodToolsRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `production-tools/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isProductionToolsHidden = false;
          });
          DEVICES.forEach((routeItem: RouteObject) => {
            this.devicesRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `devices/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isDevicesHidden = false;
            console.log(this.devicesRoutes)
          });
          REPORTS.forEach((routeItem: RouteObject) => {
            this.reportsRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `/reports/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isReportsHidden = false;
          });
          SERVICE.forEach((routeItem: RouteObject) =>{
            this.serviceRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `sementest/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isServiceHidden = false;
          });
          DATA_ANALYSIS.forEach((routeItem: RouteObject) =>{
            this.dataAnalysisRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `data-analysis/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isDataAnalysisHidden = false;
          });
          
          CONNECTORS.forEach((routeItem: RouteObject) =>{
            this.connectorsRoutes.push({routeForHide: perms[routeItem.childRoute], childRoute: `connectors/${routeItem.childRoute}`, title: routeItem.title});
            if (perms[routeItem.childRoute] === true) this.isConnectorsHidden = false;
          });

          
          console.log('++++++++++++++ SIDEBAR READY +++++++++++++++');
        };
      });
    });
  }

  isRoutePermitted(route: string): boolean {
    console.log(this.permissions[route])
    return this.permissions[route];
  }
  
  initLeftSidebar() {

    var _this = this;
    var $body = $("body");
    var $overlay = $(".overlay");

    //Close sidebar
    $(window).on("click", function (e) {
     
      var $target = $(e.target);
      if (e.target.nodeName.toLowerCase() === "i") {
        $target = $(e.target).parent();
      }

      if (
        !$target.hasClass("bars") &&
        _this.isOpen() &&
        $target.parents("#leftsidebar").length === 0
      ) {
        if (!$target.hasClass("js-right-sidebar")) $overlay.fadeOut();
        $body.removeClass("overlay-open");
      }
    });

    // $.each($(".menu-toggle.toggled"), function (i, val) {
    //   $(val)
    //     .next()
    //     .slideToggle(0);
    // });
    
    //Collapse or Expand Menu
    $(".menu-toggle").on("click", function (e) {
      var $this = $(this);
      var $content = $this.next();

      if ($($this.parents("ul")[0]).hasClass("list")) {
        var $not = $(e.target).hasClass("menu-toggle")
          ? e.target
          : $(e.target).parents(".menu-toggle");

        $.each(
          $(".menu-toggle.toggled")
            .not($not)
            .next(),
          function (i, val) {
            if ($(val).is(":visible")) {
              $(val)
                .prev()
                .toggleClass("toggled");
              $(val).slideUp();
            }
          }
        );
      }

      $this.toggleClass("toggled");
      $content.slideToggle(320);
    });

    //Set menu height
    _this.setMenuHeight(true);
    _this.checkStatuForResize(true);
    $(window).resize(function () {
      _this.setMenuHeight(false);
      _this.checkStatuForResize(false);
    });

    //Set Waves
    Waves.attach(".menu .list a", ["waves-block"]);
    Waves.init();

  }
  setMenuHeight(isFirstTime) {
    if (typeof $.fn.slimScroll != "undefined") {
      var height = $(window).height() - $(".navbar").innerHeight();
      var $el = $(".list");

      $el.slimscroll({
        height: height + "px",
        color: 'rgba(0,0,0,0.5)',
        size: '4px',
        alwaysVisible: false,
        borderRadius: '0',
        railBorderRadius: '0'
      });

    }
  }

  isOpen() {
    return $('body').hasClass('overlay-open');
  }
  checkStatuForResize(firstTime) {
    var $body = $('body');
    var $openCloseBar = $('.navbar .navbar-header .bars');
    var width = $body.width();

    if (firstTime) {
      $body.find('.content, .sidebar').addClass('no-animate').delay(1000).queue(function () {
        $(this).removeClass('no-animate').dequeue();
      });
    }

    if (width < 1170) {
      $body.addClass('ls-closed');
      $openCloseBar.fadeIn();
    }
    else {
      $body.removeClass('ls-closed');
      $openCloseBar.fadeOut();
    }
  }
  sidemenuCollapse() {
    $(".sidemenu-collapse").on("click", function () {
      var $body = $("body");
      if ($body.hasClass("side-closed")) {
        $body.removeClass("side-closed");
        $body.removeClass("submenu-closed");
      } else {
        $body.addClass("side-closed");
        $body.addClass("submenu-closed");
      }
    });
    $(".content, .navbar").mouseenter(function () {
      var $body = $("body");
      $body.removeClass("side-closed-hover");
      $body.addClass("submenu-closed");
    });
    $(".sidebar").mouseenter(function () {
      var $body = $("body");
      $body.addClass("side-closed-hover");
      $body.removeClass("submenu-closed");
    });

    if (localStorage.getItem("sidebar_option")) {
      jQuery("body").addClass(localStorage.getItem("sidebar_option"));
    }
    if ($("body").hasClass("side-closed")) {
      $(".sidebar-user-panel").css({ display: "none" });
    } else {
      $(".sidebar-user-panel").css({ display: "block" });
    }
    jQuery(document).on("click", ".sidemenu-collapse", function () {
      var sidebar_option = "";
      if ($("body").hasClass("side-closed")) {
        var sidebar_option = "side-closed submenu-closed";
        $(".sidebar-user-panel").css({ display: "none" });
      } else {
        $(".sidebar-user-panel").css({ display: "block" });
      }
      jQuery("body").addClass(sidebar_option);
      localStorage.setItem("sidebar_option", sidebar_option);
    });

  }

}
